import { fromJS } from 'immutable';
import { fromPairs, map, get, omit } from 'lodash-es';

import { locale } from '../Tools/reducers';
import { getErrorMessage } from '../utils';
import * as types from './actionTypes';
import * as systemTypes from '../System/actionTypes';
import * as partiesTypes from '../Parties/actionTypes';
import * as contractsTypes from '../Contracts/actionTypes';
// import initialState from '../../Store/initialState';
import { extractErrorMessages, getSuccessMessage, downloadPDF } from '../../Utils/Utils';

import {
  getQuotation,
  getQuotationList,
  updateQuotationList,
  getQuotationWithProduct,
  getLoanKinds,
  formatValidateMessage,
} from './transform';
import { getQuotationFromSalesRoute, getQuotationWithProductFromSR } from './transformToQuotation';
import { getOfferFromV2 } from './transformOfferToV1';

let newState;
let newConfig;
let newQuotation;
// const arrayToObject = (arr, keyField) =>
//   Object.assign({}, ...arr.map(item => ({ [item[keyField]]: item })));

const putQuotationAndProductInState = (state, action) => {
  // set/update loan kinds in store
  newConfig = getLoanKinds(get(action, 'data.product[0]'));

  newState = state.setIn(['products', get(action, 'data.productId')], fromJS(get(action, 'data.product[0]')));
  newState = newState.setIn(['productsCalc', get(action, 'data.productId')], fromJS(get(action, 'data.productCalc')));
  const quotWithProduct = getQuotationWithProductFromSR(get(action, 'data.quotation', {}), newState);
  newState = newState.setIn(['quotations', quotWithProduct.id], fromJS(quotWithProduct));
  newState = newState.setIn(['config', 'loan', 'kind', 'options'], fromJS(newConfig));

  // Keep offer from SR to use it for patching SR
  newState = newState.setIn(
    ['offerV2', quotWithProduct.id],
    fromJS(map(get(action, 'data.quotation.contracts', []), ({ offer }) => offer || []))
  );

  return newState;
};

const quotations = (state, action) => {
  switch (action.type) {
    // NEW QUOTATION
    case types.FETCH_NEW_QUOTATION_REQUEST: {
      newState = state.setIn(['loading', 'isCreatingQuotations'], true);
      return newState;
    }

    case types.FETCH_NEW_QUOTATION_SUCCESS: {
      newState = state.setIn(['quotations', action.data.id], fromJS(action.data));
      newState = newState.setIn(['loading', 'isCreatingQuotations'], false);
      newState = newState.setIn(['current'], fromJS({ redirect: true, quotationID: action.data.id }));
      return fromJS(newState);
    }

    case types.FETCH_NEW_QUOTATION_FAIL: {
      newState = state.mergeDeep(
        state,
        fromJS({
          current: { redirect: false, quotationID: undefined },
        })
      );
      newState = newState.setIn(['loading', 'isCreatingQuotations'], false);
      newState = newState.setIn(['alerts', 'errors'], getErrorMessage(action));
      return newState;
    }

    // NEW QUOTATION AS SALESROUTE
    case types.FETCH_NEW_QUOTATION_SR_REQUEST: {
      newState = state.setIn(['loading', 'isCreatingQuotations'], true);
      return newState;
    }

    case types.FETCH_NEW_QUOTATION_SR_SUCCESS: {
      newState = putQuotationAndProductInState(state, action);
      newState = newState.setIn(['loading', 'isCreatingQuotations'], false);
      newState = newState.setIn(
        ['current'],
        fromJS({ redirect: true, quotationID: get(action, 'data.quotation._id') })
      );
      return fromJS(newState);
    }

    case types.FETCH_NEW_QUOTATION_SR_FAIL: {
      newState = state.mergeDeep(
        state,
        fromJS({
          current: { redirect: false, quotationID: undefined },
        })
      );
      newState = newState.setIn(['loading', 'isCreatingQuotations'], false);
      newState = newState.setIn(['alerts', 'errors'], getErrorMessage(action));
      return newState;
    }

    case types.FETCH_QUOTATION_REQUEST: {
      newState = state.mergeDeep(
        state,
        fromJS({
          current: { redirect: false, quotationID: undefined },
        })
      );
      newState = newState.setIn(['loading', 'isLoadingQuotation'], true);
      newState = newState.setIn(['validate'], fromJS({}));
      return newState;
    }

    case types.FETCH_QUOTATION_SUCCESS: {
      // set/update quotation in store
      const quotWithProduct = getQuotationWithProduct(get(action, 'data', {}), state);

      newState = state.setIn(['quotations', action.id], fromJS(getQuotation(quotWithProduct)));
      newState = newState.setIn(['loading', 'isLoadingQuotation'], false);
      return newState;
    }

    case types.FETCH_QUOTATION_FAIL: {
      newState = state.setIn(['quotations', action.id], undefined);
      newState = newState.setIn(['loading', 'isLoadingQuotation'], false);
      newState = newState.setIn(['alerts', 'errors'], getErrorMessage(action));
      return newState;
    }

    case types.FETCH_QUOTATION_SR_REQUEST: {
      newState = state.mergeDeep(
        state,
        fromJS({
          current: { redirect: false, quotationID: undefined },
        })
      );
      newState = newState.setIn(['loading', 'isLoadingQuotation'], true);
      newState = newState.setIn(['validate'], fromJS({}));
      return newState;
    }

    case types.FETCH_QUOTATION_SR_SUCCESS: {
      newState = state.setIn(['commercialproducts'], fromJS(get(action, 'data.commercialproducts', [])));
      newState = putQuotationAndProductInState(newState, action);
      newState = newState.setIn(['loading', 'isLoadingQuotation'], false);
      return newState;
    }

    case types.FETCH_QUOTATION_SR_FAIL: {
      newState = state.setIn(['quotations', action.id], undefined);
      newState = newState.setIn(['loading', 'isLoadingQuotation'], false);
      newState = newState.setIn(['alerts', 'errors'], getErrorMessage(action));
      return newState;
    }

    // FETCH QUOTATIONS
    case types.FETCH_QUOTATIONS_REQUEST: {
      newState = state.setIn(['loading', 'isLoadingQuotations'], true);
      return newState;
    }

    case types.FETCH_QUOTATIONS_SUCCESS: {
      newState = state.setIn(['quotations'], fromJS(fromPairs(map(action.data, i => [i.id, i]))));
      newState = newState.setIn(['list'], fromJS(getQuotationList(action.data)));
      newState = newState.setIn(['loading', 'isLoadingQuotations'], false);
      return newState;
    }

    case types.FETCH_QUOTATIONS_FAIL: {
      newState = state.mergeDeep(
        state,
        fromJS({
          quotations: [],
          list: [],
        })
      );
      newState = newState.setIn(['loading', 'isLoadingQuotations'], false);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // FETCH QUOTATIONS AS SALESROUTE
    case types.FETCH_QUOTATIONS_SR_REQUEST: {
      newState = state.setIn(['loading', 'isLoadingQuotations'], true);
      return newState;
    }

    case types.FETCH_QUOTATIONS_SR_SUCCESS: {
      newState = state.setIn(['commercialproducts'], fromJS(get(action, 'data.commercialproducts', [])));
      const quots = map(get(action, 'data.quotations', []), sr => getQuotationFromSalesRoute(sr, {}, newState));
      newState = newState.setIn(['quotations'], fromJS(fromPairs(map(quots, i => [i.id, i]))));
      newState = newState.setIn(['list'], fromJS(getQuotationList(quots)));
      newState = newState.setIn(['loading', 'isLoadingQuotations'], false);
      return newState;
    }

    case types.FETCH_QUOTATIONS_SR_FAIL: {
      newState = state.mergeDeep(
        state,
        fromJS({
          quotations: [],
          list: [],
        })
      );
      newState = newState.setIn(['loading', 'isLoadingQuotations'], false);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // PUT QUOTATION
    case types.PUT_QUOTATION_REQUEST: {
      newState = state.setIn(['loading', 'isSavingQuotation'], true);
      return newState;
    }

    case types.PUT_QUOTATION_SUCCESS: {
      // update quotation in store
      const quotWithProduct = getQuotationWithProduct(get(action, 'data', {}), state);

      newState = state.setIn(['quotations', action.data.id], fromJS(quotWithProduct));
      newState = newState.setIn(['alerts', 'errors'], []);
      // newState = newState.setIn(['alerts', 'successes'], ['quotation saved successfully']);
      newState = newState.setIn(['loading', 'isSavingQuotation'], false);
      // newState = state.mergeDeep(state, newState);
      return newState;
    }

    case types.PUT_QUOTATION_FAIL: {
      newState = state.setIn(['loading', 'isSavingQuotation'], false);
      newState = newState.setIn(['alerts', 'successes'], []);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // PUT QUOTATION AS SALESROUTE
    case types.PUT_QUOTATION_SR_REQUEST: {
      newState = state.setIn(['loading', 'isSavingQuotation'], true);
      return newState;
    }

    case types.PUT_QUOTATION_SR_SUCCESS: {
      // update quotation in store
      const quotWithProduct = getQuotationWithProductFromSR(get(action, 'data', {}), state);
      newState = state.setIn(['quotations', quotWithProduct.id], fromJS(quotWithProduct));
      newState = newState.setIn(['alerts', 'errors'], []);
      // newState = newState.setIn(['alerts', 'successes'], ['quotation saved successfully']);
      newState = newState.setIn(['loading', 'isSavingQuotation'], false);
      // newState = state.mergeDeep(state, newState);
      return newState;
    }

    case types.PUT_QUOTATION_SR_FAIL: {
      newState = state.setIn(['loading', 'isSavingQuotation'], false);
      newState = newState.setIn(['alerts', 'successes'], []);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // === SUBMIT QUOTATION ===
    case types.SUBMIT_QUOTATION_REQUEST: {
      newState = state.setIn(['loading', 'isSubmittingQuotation'], true);
      return newState;
    }

    case types.SUBMIT_QUOTATION_SUCCESS: {
      // update quotation in store
      newQuotation = state.toJS().quotations[get(action, 'id')];
      newState = state.setIn(
        ['quotations', get(action, 'id')],
        fromJS({
          ...newQuotation,
          quote_status: 'submitted',
          contracts: fromJS([get(action, 'data.res.id')]),
        })
      );
      newState = newState.setIn(['contracts', get(action, 'data.res.id')], fromJS(get(action, 'data.res')));
      newState = newState.setIn(['alerts', 'errors'], []);
      // newState = newState.setIn(['alerts', 'successes'], ['quotation submitted successfully']);
      newState = newState.setIn(['loading', 'isSubmittingQuotation'], false);
      newState = newState.setIn(['current', 'contract'], fromJS(get(action, 'data.res.id')));
      // newState = state.mergeDeep(state, newState);
      return newState;
    }

    case contractsTypes.FETCH_CONTRACT_SUCCESS: {
      newState = state.setIn(['current', 'contract'], undefined);
      return newState;
    }

    case types.SUBMIT_QUOTATION_FAIL: {
      newState = state.setIn(['loading', 'isSubmittingQuotation'], false);
      newState = newState.setIn(['alerts', 'successes'], []);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // === CALCULATE QUOTATION ===
    case types.FETCH_CALCULATE_REQUEST: {
      newState = state.setIn(['loading', 'isSavingQuotation'], true);
      newState = newState.setIn(['loading', 'isCalculatingQuotation'], true);
      return newState;
    }

    case types.FETCH_CALCULATE_SUCCESS: {
      // update quotation in store
      newQuotation = state.toJS().quotations[action.id];
      newState = state.setIn(['quotations', action.id], fromJS({ ...newQuotation, offer: action.data }));
      newState = newState.setIn(['alerts', 'errors'], []);
      // newState = newState.setIn(['alerts', 'successes'], ['quotation calculated successfully']);
      newState = newState.setIn(['loading', 'isCalculatingQuotation'], false);
      // newState = state.mergeDeep(state, newState);
      return newState;
    }

    case types.FETCH_CALCULATE_FAIL: {
      newState = state.setIn(['loading', 'isCalculatingQuotation'], false);
      newState = newState.setIn(['alerts', 'successes'], []);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // === CALCULATE QUOTATION AS SALESROUTE ===
    case types.FETCH_CALCULATE_SR_REQUEST: {
      newState = state.setIn(['loading', 'isSavingQuotation'], true);
      newState = newState.setIn(['loading', 'isCalculatingQuotation'], true);
      return newState;
    }

    case types.FETCH_CALCULATE_SR_SUCCESS: {
      // update quotation in store
      const quotWithProduct = getQuotationWithProduct(get(action, 'data.quotation', {}), state);
      // Convert SR offer (V2) to quotation offer
      quotWithProduct.offer = getOfferFromV2(
        get(action, 'data.salesroute.contracts', []),
        get(action, 'data.salesroute.parties', []),
        get(action, 'data.salesroute.loans', [])
      );

      newState = state.setIn(['quotations', action.id], fromJS(quotWithProduct));
      newState = newState.setIn(['alerts', 'errors'], []);
      // newState = newState.setIn(['alerts', 'successes'], ['quotation calculated successfully']);
      newState = newState.setIn(['loading', 'isCalculatingQuotation'], false);
      // newState = state.mergeDeep(state, newState);

      // Keep offer from SR to use it for patching SR
      newState = newState.setIn(
        ['offerV2', action.id],
        fromJS(map(get(action, 'data.salesroute.contracts', []), ({ offer }) => offer || []))
      );

      return newState;
    }

    case types.FETCH_CALCULATE_SR_FAIL: {
      newQuotation = state.getIn(['quotations', get(action, 'id')]).toJS();
      newQuotation = omit(newQuotation, ['offer']);
      newState = state.setIn(['loading', 'isCalculatingQuotation'], false);
      newState = newState.setIn(['quotations', action.id], fromJS(newQuotation));
      newState = newState.setIn(['alerts', 'successes'], []);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // === CANCEL QUOTATION ===
    case types.CANCEL_QUOTATION_REQUEST: {
      newState = state.setIn(['loading', 'isCancelingQuotation'], true);
      return newState;
    }

    case types.CANCEL_QUOTATION_SUCCESS: {
      // update quotation in store
      newQuotation = { ...state.toJS().quotations[action.id], quote_status: 'canceled' };
      newState = state.setIn(['quotations', action.id], fromJS(newQuotation));
      newState = newState.setIn(['list'], fromJS(updateQuotationList(state.getIn(['list']).toJS(), newQuotation)));
      newState = newState.setIn(['alerts', 'errors'], []);
      // newState = newState.setIn(['alerts', 'successes'], ['quotation canceled successfully']);
      newState = newState.setIn(['loading', 'isCancelingQuotation'], false);
      // newState = state.mergeDeep(state, newState);
      return newState;
    }

    case types.CANCEL_QUOTATION_FAIL: {
      newState = state.setIn(['loading', 'isCancelingQuotation'], false);
      newState = newState.setIn(['alerts', 'successes'], []);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // === CANCEL QUOTATION AS SALESROUTE ===
    case types.CANCEL_QUOTATION_SR_REQUEST: {
      newState = state.setIn(['loading', 'isCancelingQuotation'], true);
      return newState;
    }

    case types.CANCEL_QUOTATION_SR_SUCCESS: {
      // update quotation in store
      newQuotation = { ...state.toJS().quotations[action.id], quote_status: 'canceled' };
      newState = state.setIn(['quotations', action.id], fromJS(newQuotation));
      newState = newState.setIn(['list'], fromJS(updateQuotationList(state.getIn(['list']).toJS(), newQuotation)));
      newState = newState.setIn(['alerts', 'errors'], []);
      // newState = newState.setIn(['alerts', 'successes'], ['quotation canceled successfully']);
      newState = newState.setIn(['loading', 'isCancelingQuotation'], false);
      // newState = state.mergeDeep(state, newState);
      return newState;
    }

    case types.CANCEL_QUOTATION_SR_FAIL: {
      newState = state.setIn(['loading', 'isCancelingQuotation'], false);
      newState = newState.setIn(['alerts', 'successes'], []);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // === PUTONHOLD QUOTATION ===
    case types.PUTONHOLD_QUOTATION_REQUEST: {
      newState = state.setIn(['loading', 'isPendingQuotation'], true);
      return newState;
    }

    case types.PUTONHOLD_QUOTATION_SUCCESS: {
      // update quotation in store
      newQuotation = { ...state.toJS().quotations[action.id], quote_status: 'pending' };
      newState = state.setIn(['quotations', action.id], fromJS(newQuotation));
      newState = newState.setIn(['list'], fromJS(updateQuotationList(state.getIn(['list']).toJS(), newQuotation)));
      newState = newState.setIn(['alerts', 'errors'], []);
      // newState = newState.setIn(['alerts', 'successes'], ['quotation put in hold successfully']);
      newState = newState.setIn(['loading', 'isPendingQuotation'], false);
      // newState = state.mergeDeep(state, newState);
      return newState;
    }

    case types.PUTONHOLD_QUOTATION_FAIL: {
      newState = state.setIn(['loading', 'isPendingQuotation'], false);
      newState = newState.setIn(['alerts', 'successes'], []);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    case types.FETCH_PRODUCT_REQUEST: {
      newState = state.mergeDeep(
        state,
        fromJS({
          current: { redirect: false, productID: undefined },
        })
      );
      newState = newState.setIn(['loading', 'isLoadingProduct'], true);
      newState = newState.setIn(['validate'], fromJS({}));
      return newState;
    }

    case types.FETCH_PRODUCT_SUCCESS: {
      // set/update product and loan kinds in store
      newConfig = getLoanKinds(get(action, 'data[0]'));

      newState = state.setIn(['products', action.id], fromJS(get(action, 'data[0]')));
      newState = newState.setIn(['config', 'loan', 'kind', 'options'], fromJS(newConfig));
      newState = newState.setIn(['loading', 'isLoadingProduct'], false);
      return newState;
    }

    case types.FETCH_PRODUCT_FAIL: {
      newState = state.setIn(['products', action.id], undefined);
      newState = newState.setIn(['loading', 'isLoadingProduct'], false);
      newState = newState.setIn(['alerts', 'errors'], getErrorMessage(action));
      return newState;
    }

    // LENDERS
    case types.FETCH_LENDERS_REQUEST: {
      newState = state.setIn(['loading', 'isLoadingLenders'], true);
      return newState;
    }

    case types.FETCH_LENDERS_SUCCESS: {
      newConfig = Array.isArray(action.data)
        ? action.data.map(lender => ({
          value: get(lender, 'id'),
          label: get(lender, 'rec_name'),
          code: get(lender, 'code'),
        }))
        : [];
      newState = newState.setIn(['config', 'loan', 'lenders', 'options'], fromJS(newConfig));
      newState = newState.setIn(['loading', 'isLoadingLenders'], false);
      newState = newState.setIn(['alerts', 'errors'], []);
      return newState;
    }

    case types.FETCH_LENDERS_FAIL: {
      newState = state.setIn(['loading', 'isLoadingLenders'], false);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // LENDER_ADDRESSES
    case types.FETCH_LENDER_ADDRESSES_REQUEST: {
      newState = state.setIn(['loading', 'isLoadingLenderAddresses'], true);
      return newState;
    }

    case types.FETCH_LENDER_ADDRESSES_SUCCESS: {
      // newConfig = Array.isArray(action.data) ? arrayToObject(action.data, 'id') : {};
      newConfig = {
        [action.id]: Array.isArray(action.data)
          ? action.data.map(lenderAddress => ({
            value: get(lenderAddress, 'id'),
            label: get(
              lenderAddress,
              'rec_name',
              `${get(lenderAddress, 'street', '')} ${get(lenderAddress, 'zip', '')} ${get(lenderAddress, 'city', '')}`
            ),
          }))
          : [],
        ...state.getIn(['config', 'loan', 'lenderAddresses', 'options']).toJS(),
      };
      newState = state.setIn(['config', 'loan', 'lenderAddresses', 'options'], fromJS(newConfig));
      newState = newState.setIn(['loading', 'isLoadingLenderAddresses'], false);
      return newState;
    }

    // LOCALE
    case systemTypes.FETCH_USER_LANGUAGE: {
      newState = state.set('strings', locale(action?.data?.language, 'quotations'));
      newState = newState.setIn(['loading', 'isLocaleLoaded'], true);
      return newState;
    }

    case types.FETCH_LENDER_ADDRESSES_FAIL: {
      newState = state.setIn(['loading', 'isLoadingLenderAddresses'], false);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // KINDS
    case types.FETCH_KINDS_REQUEST: {
      newState = state.setIn(['loading', 'isLoadingKinds'], true);
      return newState;
    }

    case types.FETCH_KINDS_SUCCESS: {
      newConfig =
        action.data && action.data.desc && Array.isArray(action.data.desc.selection)
          ? action.data.desc.selection.map(kind => ({
            value: kind[0],
            text: kind[1],
          }))
          : [];
      newState = newState.setIn(['config', 'loan', 'kind', 'options'], fromJS(newConfig));
      newState = newState.setIn(['loading', 'isLoadingKinds'], false);
      return newState;
    }

    case types.FETCH_KINDS_FAIL: {
      newState = state.setIn(['loading', 'isLoadingKinds'], false);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // DEFERRALS
    case types.FETCH_DEFERRALS_REQUEST: {
      newState = state.setIn(['loading', 'isLoadingDeferrals'], true);
      return newState;
    }

    case types.FETCH_DEFERRALS_SUCCESS: {
      newConfig =
        action.data && action.data.desc && Array.isArray(action.data.desc.selection)
          ? action.data.desc.selection.map(deferral => ({
            value: deferral[0],
            text: deferral[1],
          }))
          : [];
      newState = newState.setIn(['config', 'loan', 'lenders', 'deferrals'], fromJS(newConfig));
      newState = newState.setIn(['loading', 'isLoadingDeferrals'], false);
      return newState;
    }

    case types.FETCH_DEFERRALS_FAIL: {
      newState = state.setIn(['loading', 'isLoadingDeferrals'], false);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // GENDERS
    case partiesTypes.FETCH_GENDERS_REQUEST: {
      newState = state.setIn(['loading', 'isLoadingGenders'], true);
      return newState;
    }

    case partiesTypes.FETCH_GENDERS_SUCCESS: {
      newConfig =
        action.data && action.data.desc && Array.isArray(action.data.desc.selection)
          ? action.data.desc.selection.map(deferral => ({
            value: deferral[0],
            text: deferral[1],
          }))
          : [];
      newState = newState.setIn(['config', 'covered', 'genders', 'options'], fromJS(newConfig));
      newState = newState.setIn(['loading', 'isLoadingGenders'], false);
      return newState;
    }

    case partiesTypes.FETCH_GENDERS_FAIL: {
      newState = state.setIn(['loading', 'isLoadingGenders'], false);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // BANKS
    case types.FETCH_BANKS_REQUEST: {
      newState = state.setIn(['loading', 'isLoadingBanks'], true);
      return newState;
    }

    case types.FETCH_BANKS_SUCCESS: {
      newConfig =
        action.data && action.data && Array.isArray(action.data)
          ? action.data.map(bank => ({
            value: bank.bic,
            label: bank.rec_name,
          }))
          : [];
      newState = newState.setIn(['config', 'covered', 'banks', 'options'], fromJS(newConfig));
      newState = newState.setIn(['loading', 'isLoadingBanks'], false);
      return newState;
    }

    case types.FETCH_BANKS_FAIL: {
      newState = state.setIn(['loading', 'isLoadingBanks'], false);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // REDIRECT
    case types.SET_REDIRECT: {
      newState = state.mergeDeep(
        state,
        fromJS({
          current: { redirect: false, quotationID: undefined },
        })
      );
      return newState;
    }
    // PRINT QUOTATION
    case types.PRINT_QUOTATION_REQUEST: {
      newState = state.setIn(['loading', 'isPrintingQuotations'], true);
      return newState;
    }

    case types.PRINT_QUOTATION_SUCCESS: {
      newState = state.setIn(['loading', 'isPrintingQuotations'], false);
      newState = newState.setIn(['alerts', 'successes'], fromJS([getSuccessMessage('Ok')]));
      newState = newState.setIn(['alerts', 'errors'], []);
      // hack to start download when ready
      downloadPDF(get(action, 'data.data.base64'));
      newState = newState.setIn(
        ['quotations', action.id, 'print'],
        fromJS({ t: Date.now(), type: 'application/pdf', base64: get(action, 'data.data.base64') })
      );
      return newState;
    }

    case types.PRINT_QUOTATION_FAIL: {
      newState = state.setIn(['loading', 'isPrintingQuotations'], false);
      newState = newState.setIn(['alerts', 'successes'], []);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // PRINT QUOTATION AS SALESROUTE
    case types.PRINT_QUOTATION_SR_REQUEST: {
      newState = state.setIn(['loading', 'isPrintingQuotations'], true);
      return newState;
    }

    case types.PRINT_QUOTATION_SR_SUCCESS: {
      newState = state.setIn(['loading', 'isPrintingQuotations'], false);
      newState = newState.setIn(['alerts', 'successes'], fromJS([getSuccessMessage('Ok')]));
      newState = newState.setIn(['alerts', 'errors'], []);
      // hack to start download when ready
      downloadPDF(get(action, 'data.data.base64'));
      newState = newState.setIn(
        ['quotations', action.id, 'print'],
        fromJS({ t: Date.now(), type: 'application/pdf', base64: get(action, 'data.data.base64') })
      );
      return newState;
    }

    case types.PRINT_QUOTATION_SR_FAIL: {
      newState = state.setIn(['loading', 'isPrintingQuotations'], false);
      newState = newState.setIn(['alerts', 'successes'], []);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // VALIDATE IBAN
    case types.VALIDATE_IBAN_REQUEST: {
      newState = state.setIn(['loading', 'isValidatingIban'], true);
      return newState;
    }

    case types.VALIDATE_IBAN_SUCCESS: {
      newConfig = get(action, 'data.bic');
      newState = state.setIn(['bic'], newConfig);
      newState = newState.setIn(['loading', 'isValidatingIban'], false);
      newState = newState.setIn(
        ['alerts', 'successes'],
        fromJS([{ t: Date.now(), msg: `IBAN OK. BIC : ${get(action, 'data.bic')}` }])
      );
      newState = newState.setIn(['alerts', 'errors'], []);
      return newState;
    }
    case types.VALIDATE_IBAN_FAIL: {
      newState = state.setIn(['loading', 'isValidatingIban'], false);
      // newState = newState.setIn(
      //   ['alerts', 'errors'],
      //   getErrorMessage(action)
      // );
      newState = newState.setIn(['alerts', 'successes'], []);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // === SUBMIT QUOTATIONS ===
    case types.SUBMIT_QUOTATIONS_REQUEST: {
      newState = state.setIn(['loading', 'isSubmittingQuotations'], true);
      return newState;
    }

    case types.SUBMIT_QUOTATIONS_SUCCESS: {
      // update quotation in store
      newQuotation = state.toJS().quotations[get(action, 'id')];
      newState = state.setIn(
        ['quotations', get(action, 'id')],
        fromJS({
          ...newQuotation,
          quote_status: 'submitted',
          contracts: fromJS([get(action, 'data.res.id')]),
        })
      );
      newState = newState.setIn(['contracts', get(action, 'data.res.id')], fromJS(get(action, 'data.res')));
      newState = newState.setIn(['alerts', 'errors'], []);
      // newState = newState.setIn(['alerts', 'successes'], ['quotation submitted successfully']);
      newState = newState.setIn(['loading', 'isSubmittingQuotations'], false);
      newState = newState.setIn(['current', 'contracts'], fromJS(get(action, 'data.contracts')));

      const quotWithProduct = getQuotationWithProduct(get(action, 'data', {}), state);
      newState = newState.setIn(['quotations', get(action, 'id')], fromJS(getQuotation(quotWithProduct)));
      // newState = state.mergeDeep(state, newState);
      return newState;
    }

    case types.SUBMIT_QUOTATIONS_FAIL: {
      newState = state.setIn(['loading', 'isSubmittingQuotations'], false);
      newState = newState.setIn(['alerts', 'successes'], []);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      newState = newState.setIn(['current', 'contracts'], undefined);
      return newState;
    }

    // === SUBMIT QUOTATIONS AS SALESROUTE ===
    case types.SUBMIT_QUOTATIONS_SR_REQUEST: {
      newState = state.setIn(['loading', 'isSubmittingQuotations'], true);
      return newState;
    }

    case types.SUBMIT_QUOTATIONS_SR_SUCCESS: {
      // update quotation in store
      newQuotation = state.getIn(['quotations', get(action, 'id')]).toJS();
      newState = newState.setIn(['contracts', get(action, 'data.id')], fromJS(get(action, 'data')));
      newState = newState.setIn(['alerts', 'errors'], []);
      // newState = newState.setIn(['alerts', 'successes'], ['quotation submitted successfully']);
      newState = newState.setIn(['loading', 'isSubmittingQuotations'], false);
      newState = newState.setIn(['current', 'contracts'], fromJS(get(action, 'data.contracts')));

      const quotWithProduct = getQuotationWithProduct({ ...newQuotation, ...action.data }, state);
      newState = newState.setIn(['quotations', get(action, 'id')], fromJS(quotWithProduct));
      return newState;
    }

    case types.SUBMIT_QUOTATIONS_SR_FAIL: {
      newState = state.setIn(['loading', 'isSubmittingQuotations'], false);
      newState = newState.setIn(['alerts', 'successes'], []);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      newState = newState.setIn(['current', 'contracts'], undefined);
      return newState;
    }

    // VALIDATE QUOTATION
    case types.VALIDATE_QUOTATION_REQUEST: {
      newState = state.setIn(['loading', 'isValidatingQuotation'], true);
      return newState;
    }

    case types.VALIDATE_QUOTATION_SUCCESS: {
      newState = state.setIn(['validate'], fromJS({ t: Date.now(), ...get(action, 'data') }));
      newState = newState.setIn(['loading', 'isValidatingQuotation'], false);
      return newState;
    }

    case types.VALIDATE_QUOTATION_FAIL: {
      newState = state.setIn(['loading', 'isValidatingQuotation'], false);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // VALIDATE QUOTATION AS SALESROUTE
    case types.VALIDATE_QUOTATION_SR_REQUEST: {
      newState = state.setIn(['loading', 'isValidatingQuotation'], true);
      return newState;
    }

    case types.VALIDATE_QUOTATION_SR_SUCCESS: {
      newState = state.setIn(
        ['validate'],
        fromJS({ t: Date.now(), ...formatValidateMessage(get(action, 'data'), state.get('strings')) })
      );
      newState = newState.setIn(['loading', 'isValidatingQuotation'], false);
      return newState;
    }

    case types.VALIDATE_QUOTATION_SR_FAIL: {
      newState = state.setIn(['loading', 'isValidatingQuotation'], false);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    // === DUPLICATE QUOTATIONS AS SALESROUTE ===
    case types.DUPLICATE_QUOTATION_SR_REQUEST: {
      newState = state.setIn(['loading', 'isLoadingValidate'], true);
      newState = newState.setIn(['duplicateSR'], fromJS({}));
      return newState;
    }

    case types.DUPLICATE_QUOTATION_SR_SUCCESS: {
      newState = state.setIn(['loading', 'isLoadingValidate'], false);
      newState = newState.setIn(['duplicateSR', 'id'], fromJS(action?.data?.data?._id));
      newState = newState.setIn(
        ['duplicateSR', 'productId'],
        fromJS(action?.data?.data?.contracts?.[0]?.commercial_product?.id)
      );

      return newState;
    }

    case types.DUPLICATE_QUOTATION_SR_FAIL: {
      newState = state.setIn(['loading', 'isLoadingValidate'], false);
      newState = newState.setIn(['duplicateSR'], fromJS({}));
      newState = newState.setIn(['alerts', 'successes'], []);
      newState = newState.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    case types.NEED_RECALCULATE: {
      newState = state.setIn(['alerts', 'errors'], fromJS(extractErrorMessages(get(action, 'error'))));
      return newState;
    }

    case types.RESET_OFFER: {
      newState = state.setIn(['quotations', get(action, 'id'), 'offer'], fromJS({}));
      return newState;
    }

    default:
      return state;
  }
};
export default quotations;
